import React from 'react';

export const ChangePasswordField = props =>
  props.visible && (
    <div className="row">
      <div className="col-12">
        <button
          className="btn btn-outline-primary"
          type="button"
          onClick={() => props.onChange({ target: { checked: !props.value } })}
        >
          {props.value ? 'Cancel Change Password' : 'Change Password'}
        </button>
      </div>
    </div>
  );
